import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { useTranslation } from "react-i18next";

import { isNotEmpty } from "../../Utils";

const useStyles = makeStyles({
    root: {
        width: "85%",
        height: "100%",
        margin: "6px 100px 0px 50px",
        flex: 1,
    },
    rootMobile: {
        margin: "6px 0px 0px 0px",
        flex: 1,
    },
});

function Form106SubmittedDialog({ formOpen, onConfirm, referenceNumber = "" }) {
    const { t, i18n } = useTranslation();
    // const status = useSelector(getStatus());
    let toAppro = true;
    // if (status >= 0 && status <= 8) {
    //     toAppro = true;
    // }

    return (
        <React.Fragment>
            <Dialog
                // onClose={handleClose}
                aria-labelledby="simple-dialog-title"
                open={formOpen}
            >
                <DialogTitle id="simple-dialog-title">
                    {t("common.portal.successfulFormSubmission")}
                </DialogTitle>
                <DialogContent>
                    {toAppro
                        ? t(
                              "common.portal.successfulSubmissionMsgToAForForm106"
                          )
                        : t("common.portal.successfulSubmissionMsgToA")}
                    <br />
                    <br />
                    {isNotEmpty(referenceNumber) &&
                        `${t(
                            "common.portal.referenceNum"
                        )}: ${referenceNumber}`}
                    <br />
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={onConfirm} color="success">
                        <b>{t("common.portal.close")}</b>
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
export default Form106SubmittedDialog;
